<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'

const props = defineProps<{
  label: string
  checked: boolean
}>()

const emit = defineEmits<{
  (e: 'toggle'): void
}>()

const toggleCheckbox = () => {
  emit('toggle')
}
</script>
<template>
  <div class="w-full flex items-center cursor-pointer" @click="toggleCheckbox">
    <div class="relative">
      <input type="checkbox" :checked="props.checked" class="hidden" />
      <div
        class="w-5 h-5 border-2 border-gray-300 rounded-md flex justify-center items-center transition-all duration-200 ease-in-out"
        :class="{ 'bg-blue-600 border-blue-600': props.checked }"
      >
        <svg
          v-if="props.checked"
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
        </svg>
      </div>
    </div>

    <label class="ml-3 block grow text-sm text-left select-none cursor-pointer">
      {{ props.label }}
    </label>
  </div>
</template>
